import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe, UpperCasePipe } from "@angular/common";
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbAccordionModule, NgbAlertModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { AccordionItemComponent } from './components/accordion/accordion-item/accordion-item.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { AzureMapWideComponent } from './components/azure-map/azure-map-wide/azure-map-wide.component';
import { AzureMapComponent } from './components/azure-map/azure-map.component';
import { BadgeLoadingComponent } from './components/badge-loading/badge-loading.component';
import { BadgeStatusComponent } from './components/badge-status/badge-status.component';
import { BaseContentComponent } from './components/base-content/base-content.component';
import { ButtonDownloadFileComponent } from './components/button-download-file/button-download-file.component';
import { CardComponent } from './components/card/card.component';
import { CommonModalComponent } from './components/common-modal/common-modal.component';
import { ImageViewerComponent } from './components/common-modal/image-viewer/image-viewer.component';
import { WarningModalComponent } from './components/common-modal/warning-modal/warning-modal.component';
import { ConfirmButtonComponent } from './components/confirm-button/confirm-button.component';
import { DateRangeFilterComponent } from './components/date-range-filter/date-range-filter.component';
import { DetailListComponent } from './components/detail-list/detail-list.component';
import { DragDropFileComponent } from './components/drag-drop-file/drag-drop-file.component';
import { DropdownOptionCheckboxComponent } from './components/dropdown-option-checkbox/dropdown-option-checkbox.component';
import { FieldLabelComponent } from './components/field-label/field-label.component';
import { GenericDetailsAccordionComponent } from './components/generic-details-accordion/generic-details-accordion.component';
import { GenericFormComponent } from './components/generic-form/generic-form.component';
import { GenericTableComponent } from './components/generic-table/generic-table.component';
import { IconButtonModule } from './components/icon-button/icon-button.module';
import { InfoBoxComponent } from './components/info-box/info-box.component';
import { InfoPanelComponent } from './components/info-panel/info-panel.component';
import { MediaGalleryModalComponent } from './components/media-gallery-modal/media-gallery-modal.component';
import { ModalUploadMediaComponent } from './components/modal-upload-media/modal-upload-media.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SelectFilterComponent } from './components/select-filter/select-filter.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { StickyConfirmationComponent } from './components/sticky-confirmation/sticky-confirmation.component';
import { TableXlsValidatorsComponent } from './components/table-xls-validators/table-xls-validators.component';
import { TabContentComponent } from './components/tabs/tab-content/tab-content.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { ToastComponent } from './components/toast/toast.component';
import { UncompleteDocumentModalComponent } from './components/uncomplete-document-modal/uncomplete-document-modal.component';
import { UploadFileXlsComponent } from './components/upload-file-xls/upload-file-xls.component';
import { UploadImageBoxComponent } from "./components/upload-image-box/upload-image-box.component";
import { UploadImageListComponent } from './components/upload-image-list/upload-image-list.component';
import { VeritcalStepperComponent } from './components/veritcal-stepper/veritcal-stepper.component';
import { AlphanumericDirective } from './directives/alphanumeric.directive';
import { AsciiOnlyDirective } from './directives/ascii-only.directive';
import { DateInputPatchDirective } from './directives/date-input-patch.directive';
import { ImmsFormControlDirective } from './directives/form-control/imms-form-control.directive';
import { CustomFormFieldDirective } from './directives/form-field-custom.directive';
import { FormattedNumberDirective } from "./directives/formatted-number-directive.directive";
import { MultiPhoneDirective } from './directives/multi-phone.directive';
import { NamedTemplateDirective } from './directives/named-template.directive';
import { ObserveSizeChangesDirective } from './directives/observe-element-size';
import { OnlyNumberDirectiveDirective } from './directives/only-number-directive.directive';
import { RupiahCurrencyPipe } from './directives/rupiah-currency.directive';
import { TableColumnDirective } from "./directives/table-column.directive";
import { VerticalStepperStepDirective } from './directives/vertical-stepper-step.directive';
import { DynamicPipe } from './pipes/dynamic-pipe.pipe';
import { MonthNamePipe } from './pipes/month-name.pipe';
import { SafePipe } from './pipes/sanitizer-url.pipe';

@NgModule({
  declarations: [
    ConfirmButtonComponent,
    ToastComponent,
    BadgeLoadingComponent,
    OnlyNumberDirectiveDirective,
    FormattedNumberDirective,
    AlphanumericDirective,
    BadgeStatusComponent,
    AzureMapComponent,
    ObserveSizeChangesDirective,
    AzureMapWideComponent,
    FieldLabelComponent,
    ImmsFormControlDirective,
    TableColumnDirective,
    CardComponent,
    BaseContentComponent,
    UploadImageBoxComponent,
    DynamicPipe,
    MonthNamePipe,
    GenericTableComponent,
    GenericFormComponent,
    PaginationComponent,
    AccordionComponent,
    AccordionItemComponent,
    DragDropFileComponent,
    DropdownOptionCheckboxComponent,
    VeritcalStepperComponent,
    DetailListComponent,
    NamedTemplateDirective,
    VerticalStepperStepDirective,
    GenericDetailsAccordionComponent,
    TabContentComponent,
    TabsComponent,
    DateRangeFilterComponent,
    UploadImageListComponent,
    MediaGalleryModalComponent,
    SelectFilterComponent,
    UploadFileXlsComponent,
    TableXlsValidatorsComponent,
    ModalUploadMediaComponent,
    CommonModalComponent,
    WarningModalComponent,
    ImageViewerComponent,
    UncompleteDocumentModalComponent,
    ButtonDownloadFileComponent,
    StepperComponent,
    InfoPanelComponent,
    InfoBoxComponent,
    StickyConfirmationComponent,
    CustomFormFieldDirective,
    DateInputPatchDirective,
    AsciiOnlyDirective,
    MultiPhoneDirective,
    SafePipe,
    RupiahCurrencyPipe,
  ],
  imports: [
    TranslateModule,
    InlineSVGModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgbAlertModule,
    NgbAccordionModule,
    NgbTooltipModule,
    IconButtonModule,
  ],
  exports: [
    TranslateModule,
    InlineSVGModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmButtonComponent,
    BadgeLoadingComponent,
    TabContentComponent,
    TabsComponent,
    ToastComponent,
    OnlyNumberDirectiveDirective,
    FormattedNumberDirective,
    AlphanumericDirective,
    BadgeStatusComponent,
    AzureMapComponent,
    ObserveSizeChangesDirective,
    FieldLabelComponent,
    NgbAccordionModule,
    NgbTooltipModule,
    ImmsFormControlDirective,
    GenericTableComponent,
    GenericFormComponent,
    PaginationComponent,
    TableColumnDirective,
    UploadImageBoxComponent,
    CardComponent,
    DynamicPipe,
    MonthNamePipe,
    AccordionComponent,
    AccordionItemComponent,
    DragDropFileComponent,
    DropdownOptionCheckboxComponent,
    IconButtonModule,
    VeritcalStepperComponent,
    VerticalStepperStepDirective,
    CardComponent,
    DetailListComponent,
    NamedTemplateDirective,
    DateRangeFilterComponent,
    GenericDetailsAccordionComponent,
    MediaGalleryModalComponent,
    UploadImageListComponent,
    SelectFilterComponent,
    TableXlsValidatorsComponent,
    UploadFileXlsComponent,
    CommonModalComponent,
    WarningModalComponent,
    ImageViewerComponent,
    UncompleteDocumentModalComponent,
    ButtonDownloadFileComponent,
    StepperComponent,
    InfoPanelComponent,
    InfoBoxComponent,
    StickyConfirmationComponent,
    CustomFormFieldDirective,
    DateInputPatchDirective,
    MultiPhoneDirective,
    AsciiOnlyDirective,
    RupiahCurrencyPipe,
    SafePipe
  ],
  providers: [UpperCasePipe, TranslatePipe, DatePipe, DecimalPipe, CurrencyPipe, RupiahCurrencyPipe]
})
export class SharedModule {
}
